<script setup lang="ts">
import { computed, ref } from 'vue';
import { RouterView, LoadingView } from '@hfc/ui-core';
import { AppTypeDentalOrVision } from '@/application/shared/domain/DentalAndVisionApplication';
import { PlanResponse } from '@/planList/domain/PlanResponse';
import SelectedPlan from '@/shared/infrastructure/components/SelectedPlan.vue';
import { useDentalAndVisionApplicationStore } from '@/application/shared/infrastructure/composition/useDentalAndVisionApplicationStore';

const { dentalAndVisionApplicationState } = useDentalAndVisionApplicationStore();

const props = defineProps<{
  applicationType: AppTypeDentalOrVision;
}>();

const currentPlan = computed(() => dentalAndVisionApplicationState.value[props.applicationType].plan as PlanResponse);
const effectiveDate = computed(() => dentalAndVisionApplicationState.value[props.applicationType].effective_date);
const showModal = ref(false);
</script>

<template>
  <div class="flex">
    <div v-if="dentalAndVisionApplicationState.loadingApplication" class="absolute inset-0 z-20 flex items-center justify-center bg-blue-100">
      <LoadingView class="bg-transparent" />
    </div>
    <router-view />
    <div class="lg:flex" :class="{ 'hidden': !showModal }">
      <SelectedPlan v-if="effectiveDate" @show-modal="v => showModal = v" class="pt-24 ml-7" :effective-date="effectiveDate" :show-benefits-link="true" :show-give-feedback-button="true" :plan="currentPlan" :application-type="applicationType" />
    </div>
  </div>
</template>
